"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _immutable = require("immutable");

var initialState = (0, _immutable.Map)();

function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.meta && action.meta.request) {
    return state.set(action.meta.request.key, action.meta.request.status);
  }

  return state;
}

module.exports = exports.default;